/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ProjectResearchRequest {
  url: string;
}

export interface ProjectResearchResponse {
  session_id?: string;
  stream_url?: string;
  existing_project_id?: string;
}

export interface ProjectWebResultProjectResearchResponse {
  success?: boolean;
  code?: string;
  message?: string;
  obj?: ProjectResearchResponse;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface BuyerNote {
  tags?: string[];
  text?: string;
}

export interface ProjectConfirmRequest {
  note?: BuyerNote;
}

export interface ProjectError {
  code?: string;
  reason?: string;
}

export interface ProjectRead {
  handle?: string;
  domain?: string;
  summary?: string;
  opportunity?: string;
  category?: string;
  competitors?: Record<string, string>[];
  error?: ProjectError;
  schema_version?: string;
  session_id?: string;
  project_name?: string;
  logo_url?: string;
  opportunity_source?: string;
  category_source?: string;
  target_audience?: string;
  audience_source?: string;
  competitor_source?: string;
  data_sources_hit?: Record<string, object>[];
  buyer_note?: BuyerNote;
  value_start_floor?: string;
  recommended_templates?: Record<string, object>[];
  /** @format int64 */
  recommendation_generated_at?: number;
}

export interface ProjectWebResultProjectRead {
  success?: boolean;
  code?: string;
  message?: string;
  obj?: ProjectRead;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface ProjectSubmitProposalRequest {
  action_template_name: string;
  cohort_names: string[];
  /** @format int64 */
  budget_usd: number;
}

export interface ProjectCustomActionRequest {
  /**
   * @minLength 0
   * @maxLength 500
   */
  text: string;
}

export interface ProjectPatchProposalRequest {
  action_template_name?: string;
  cohort_names?: string[];
  /** @format int64 */
  budget_usd?: number;
}

export interface SseEmitter {
  /** @format int64 */
  timeout?: number;
}

export interface MyProjectResponse {
  project?: ProjectRead;
  hasProject?: boolean;
}

export interface ProjectWebResultMyProjectResponse {
  success?: boolean;
  code?: string;
  message?: string;
  obj?: MyProjectResponse;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface CohortGroup {
  vertical?: string;
  personas?: ProjectCohortCard[];
}

export interface ProjectCohortCard {
  id?: string;
  description?: string;
  vertical?: string;
  persona_name?: string;
  verified_across?: string[];
  verified_across_domains?: string[];
  /** @format int64 */
  reach_floor?: number;
  fit_reason?: string;
  is_top?: boolean;
}

export interface ProjectCohortLibraryResponse {
  groups?: CohortGroup[];
}

export interface ProjectActionLibraryResponse {
  templates?: ProjectActionTemplateCard[];
}

export interface ProjectActionTemplateCard {
  band?: string;
  stage?: string;
  name?: string;
  desc?: string;
  /** @format int32 */
  indicative_price_usd?: number;
  is_pick?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://api.trex.dev.dipbit.xyz";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title trex api
 * @version 1.0
 * @baseUrl https://api.trex.dev.dipbit.xyz
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * No description
     *
     * @tags application-project-controller
     * @name Research
     * @request POST:/v1/projects
     */
    research: (data: ProjectResearchRequest, params: RequestParams = {}) =>
      this.request<ProjectWebResultProjectResearchResponse, any>({
        path: `/v1/projects`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags application-project-controller
     * @name Materialize
     * @request POST:/v1/projects/session/{sessionId}/materialize
     */
    materialize: (
      sessionId: string,
      query: {
        handle: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/session/${sessionId}/materialize`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags application-project-controller
     * @name Confirm
     * @request POST:/v1/projects/session/{sessionId}/confirm
     */
    confirm: (
      sessionId: string,
      query: {
        handle: string;
      },
      data: ProjectConfirmRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProjectWebResultProjectRead, any>({
        path: `/v1/projects/session/${sessionId}/confirm`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name SubmitProposal
     * @request POST:/v1/projects/proposals
     */
    submitProposal: (
      data: ProjectSubmitProposalRequest,
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/proposals`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name CohortsRecommend
     * @request POST:/v1/projects/cohorts/recommend
     */
    cohortsRecommend: (
      query: {
        action_template_name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/cohorts/recommend`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name CustomActionRequest
     * @request POST:/v1/projects/actions/request
     */
    customActionRequest: (
      data: ProjectCustomActionRequest,
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/actions/request`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name RecommendActions
     * @request POST:/v1/projects/actions/recommend
     */
    recommendActions: (params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/v1/projects/actions/recommend`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name DeleteProposal
     * @request DELETE:/v1/projects/proposals/{id}
     */
    deleteProposal: (id: string, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/v1/projects/proposals/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name PatchProposal
     * @request PATCH:/v1/projects/proposals/{id}
     */
    patchProposal: (
      id: string,
      data: ProjectPatchProposalRequest,
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/proposals/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags application-project-controller
     * @name GetProject
     * @request GET:/v1/projects/session/{sessionId}
     */
    getProject: (
      sessionId: string,
      query: {
        handle: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectWebResultProjectRead, any>({
        path: `/v1/projects/session/${sessionId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags application-project-controller
     * @name Stream
     * @request GET:/v1/projects/session/{sessionId}/stream
     */
    stream: (
      sessionId: string,
      query: {
        handle: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SseEmitter, any>({
        path: `/v1/projects/session/${sessionId}/stream`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-result-controller
     * @name GetProposal
     * @request GET:/v1/projects/proposals/{proposalId}
     */
    getProposal: (
      proposalId: string,
      query?: {
        mock?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/proposals/${proposalId}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name ListMyProposals
     * @request GET:/v1/projects/proposals/mine
     */
    listMyProposals: (params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/v1/projects/proposals/mine`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags application-project-controller
     * @name GetMyProject
     * @request GET:/v1/projects/mine
     */
    getMyProject: (params: RequestParams = {}) =>
      this.request<ProjectWebResultMyProjectResponse, any>({
        path: `/v1/projects/mine`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags application-project-controller
     * @name DeleteMyProject
     * @request DELETE:/v1/projects/mine
     */
    deleteMyProject: (params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/v1/projects/mine`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-result-controller
     * @name GetDashboard
     * @request GET:/v1/projects/dashboard
     */
    getDashboard: (
      query?: {
        mock?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/dashboard`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name CohortsLibrary
     * @request GET:/v1/projects/cohorts/library
     */
    cohortsLibrary: (params: RequestParams = {}) =>
      this.request<ProjectCohortLibraryResponse, any>({
        path: `/v1/projects/cohorts/library`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name CohortDetail
     * @request GET:/v1/projects/cohorts/detail/{name}
     */
    cohortDetail: (name: string, params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/v1/projects/cohorts/detail/${name}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-result-controller
     * @name GetVerifiedFeed
     * @request GET:/v1/projects/campaigns/{campaignId}/verified-feed
     */
    getVerifiedFeed: (
      campaignId: string,
      query?: {
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
        mock?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/campaigns/${campaignId}/verified-feed`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-result-controller
     * @name GetCampaignReport
     * @request GET:/v1/projects/campaigns/{campaignId}/report
     */
    getCampaignReport: (
      campaignId: string,
      query?: {
        mock?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/campaigns/${campaignId}/report`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-result-controller
     * @name GetCampaignReportPdf
     * @request GET:/v1/projects/campaigns/{campaignId}/report/pdf
     */
    getCampaignReportPdf: (
      campaignId: string,
      query?: {
        mock?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/campaigns/${campaignId}/report/pdf`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-result-controller
     * @name GetCampaignLive
     * @request GET:/v1/projects/campaigns/{campaignId}/live
     */
    getCampaignLive: (
      campaignId: string,
      query?: {
        mock?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<object, any>({
        path: `/v1/projects/campaigns/${campaignId}/live`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags project-campaign-controller
     * @name ActionsLibrary
     * @request GET:/v1/projects/actions/library
     */
    actionsLibrary: (params: RequestParams = {}) =>
      this.request<ProjectActionLibraryResponse, any>({
        path: `/v1/projects/actions/library`,
        method: "GET",
        ...params,
      }),
  };
}
